import BaseService from "../BaseService";
import _ from "lodash";

class UserRecoveryService extends BaseService {
    requestResetPass = async (info) => {
        var data = await this._api.post("userrecovery/requestresetpass", info);
        return data;
    }
    changePassWithOTP = async (info) => {
        var data = await this._api.post("userrecovery/changepasswithotp", info);
        return data;
    }









}
export default UserRecoveryService;
